<button mat-icon-button class="button button--icon" aria-label="Toggle layout" (click)="changeLayout()" [attr.data-cy]="'list-layout-switcher-' + (layout === layouts.GRID ? layouts.ROW : layouts.GRID)">
  <lib-icon [icon]="layout === layouts.GRID ? 'rows' : 'squares-four'" [size]="24"></lib-icon>
</button>
